<div class="number-input-component"
     [formGroup]="formGroup">
  <mat-form-field>
    @if (title) {
      <mat-label>{{title}}</mat-label>
    }
    <input [inputMask]="inputMask"
           [formControl]="formControl"
           [disableControl]="disabled"
           matInput
           type="text">
    @if (hint) {
      <mat-hint>{{hint}}</mat-hint>
    }
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</div>
